import { Box, Container, Flex, useBreakpointValue } from '@chakra-ui/react';
import React from 'react';

import MobileNavFlow from '../../components/MobileNavFlow';
import Nav from '../../components/Nav/Nav';

type FlowLayoutProps = {
  children: React.ReactNode;
};

const FlowLayout = ({ children }: FlowLayoutProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Flex bgColor="grayBackground" h="100%" minH="100vh" flexDirection="column">
      <Box>{isMobile ? <MobileNavFlow /> : <Nav inFlow />}</Box>
      <Container pt={4} maxW="container.xl" flex={1}>
        {children}
      </Container>
    </Flex>
  );
};

export default FlowLayout;
